import { render } from "./TheRegistration.vue?vue&type=template&id=bdbffa30&lang=pug"
import script from "./TheRegistration.vue?vue&type=script&lang=js"
export * from "./TheRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__